import React from 'react';
import { useTranslations } from '@lang';
import { DetailsContainer, DetailsRow } from './TableDetails.styles';
import { DetailTitle } from '../../styled';
import { some } from '@utils/some';

export const TableDetails = ({ name, dietaryRequirements, celebrations }) => {
  const { t } = useTranslations();

  return (
    <DetailsContainer>
      <DetailsRow>
        <DetailTitle showOnMobile>{t('basket.menu')}</DetailTitle>
        <div>{name}</div>
      </DetailsRow>
      {some(dietaryRequirements) && (
        <DetailsRow>
          <DetailTitle showOnMobile>{t('common.dietaryRequirements')}</DetailTitle>
          <div>{(dietaryRequirements || []).join(', ')}</div>
        </DetailsRow>
      )}
      {some(celebrations) && (
        <DetailsRow>
          <DetailTitle showOnMobile>{t('common.celebrations')}</DetailTitle>
          <div>{(celebrations || []).join(', ')}</div>
        </DetailsRow>
      )}
    </DetailsContainer>
  );
};
